// extracted by mini-css-extract-plugin
export default {"app":"App_app__o0nBc","appLogo":"App_appLogo__OU93v","appLogoSpin":"App_appLogoSpin__Gu0Ol","appHeader":"App_appHeader__KQNrR","appLink":"App_appLink__UECXh"};